import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Card } from "@/components/ui/card";

const EFFECTIVE_DATE = "February 14, 2026";

const DeleteAccountPage = () => {
  return (
    <div className="min-h-screen" style={{ background: "#1a1a1e" }} data-testid="delete-account-page">
      <div className="border-b border-gray-800" style={{ background: "#0f0f11" }}>
        <div className="container-custom py-4">
          <Link to="/"><Button variant="ghost" className="text-purple-400" data-testid="delete-account-back">← Back</Button></Link>
        </div>
      </div>
      <div className="container-custom py-12">
        <div className="max-w-3xl mx-auto">
          <Card className="p-8" style={{ background: "rgba(42, 26, 58, 0.5)", borderColor: "rgba(138, 43, 226, 0.3)" }}>
            <h1 className="text-4xl font-bold text-white mb-2">Delete Your RGM Studio Account</h1>
            <p className="text-sm text-purple-300 mb-8">Effective Date: {EFFECTIVE_DATE}</p>
            <div className="space-y-6 text-gray-300 leading-relaxed">
              <p>
                If you would like to delete your RGM Studio account and associated data, please email:
              </p>
              <div
                className="px-5 py-4 rounded-xl border border-purple-400/40 bg-purple-500/10"
                data-testid="delete-account-email-block"
              >
                <p className="text-base">
                  📧{" "}
                  <a
                    className="text-purple-200 font-bold underline hover:text-amber-200"
                    href="mailto:support@rgmstudio.org?subject=Account%20Deletion%20Request"
                    data-testid="delete-account-mailto"
                  >
                    support@rgmstudio.org
                  </a>
                </p>
              </div>

              <h2 className="text-2xl font-bold text-white">Include in your request</h2>
              <ul className="list-disc pl-6 space-y-1">
                <li>Your username</li>
                <li>Your registered email address</li>
              </ul>

              <h2 className="text-2xl font-bold text-white">Processing time</h2>
              <p>
                Account deletion requests are processed within{" "}
                <span className="text-white font-semibold">7 business days</span>.
              </p>

              <h2 className="text-2xl font-bold text-white">Data retention notice</h2>
              <p>Some data may be retained temporarily for:</p>
              <ul className="list-disc pl-6 space-y-1">
                <li>Security</li>
                <li>Fraud prevention</li>
                <li>Legal compliance purposes</li>
              </ul>

              <h2 className="text-2xl font-bold text-white">What gets deleted</h2>
              <ul className="list-disc pl-6 space-y-1">
                <li>Profile information (display name, bio, photos, banner)</li>
                <li>Uploaded music, cover art, and creator content</li>
                <li>Live Beam history, messages, and recordings you hosted</li>
                <li>Gifts you've sent / received and the wallet balance attached to the account</li>
                <li>Follow relationships, playlists, quests, and reactions</li>
              </ul>

              <h2 className="text-2xl font-bold text-white">Before deleting — alternative</h2>
              <p>
                If you only want a temporary break, you can sign out and stop using the app — your
                profile will remain private to you until you return. Deleting is permanent and
                cannot be undone.
              </p>

              <h2 className="text-2xl font-bold text-white">Need help?</h2>
              <p>
                📧 <a className="text-purple-300 underline" href="mailto:support@rgmstudio.org">support@rgmstudio.org</a>
              </p>
              <p>
                🌐 <a className="text-purple-300 underline" href="https://rgmstudio.org">RGMStudio.org</a>
              </p>
            </div>
          </Card>
        </div>
      </div>
    </div>
  );
};

export default DeleteAccountPage;
